import { Box } from '@mui/material';

const OrgAvatar = ({ organization, size = 32, sx = {} }) => {
	const name = organization?.name || '';
	const logoUrl = organization?.logo_url;

	if (logoUrl) {
		return (
			<Box
				component="img"
				src={logoUrl}
				alt={name ? `${name} logo` : 'Organization logo'}
				sx={{
					width: size,
					height: size,
					objectFit: 'contain',
					borderRadius: 1,
					flexShrink: 0,
					...sx,
				}}
			/>
		);
	}

	return (
		<Box
			sx={{
				width: size,
				height: size,
				borderRadius: 1.5,
				bgcolor: 'primary.main',
				color: 'primary.contrastText',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexShrink: 0,
				fontSize: size * 0.4,
				fontWeight: 700,
				...sx,
			}}
		>
			{name.charAt(0).toUpperCase()}
		</Box>
	);
};

export default OrgAvatar;
